import React from 'react';
import PropTypes from 'prop-types';
// import { Border, Button, ButtonContainer, CalendarHeader, CalendarWrapper, ConfirmVisitText, StyledModal } from './style';
// import { AdminCloseIcon } from '../../../utils/icons';
import { Modal } from 'react-bootstrap';
import { Border, Button, ButtonContainer, CalendarHeader, CalendarWrapper, ConfirmVisitText, StyledModal } from '../common/CommonModal/style';
import { AdminCloseIcon } from '../../utils/icons';

const CompletedSurveyPopup = ({
  show,
  icon,
  buttonIcon,
  title,
  description,
  onCancel,
  onConfirm,
  cancelText,
  subDescription,
  confirmButtonText,
  modalWidth = "400px",
  modalHeight,
  confirmButtonWidth,
  onClose,
  note,
  descriptionColor,
  isFontSize,
  isPopupMargin,
  surveyPoints
}) => (
  <StyledModal show={show} width={modalWidth} height={modalHeight}>
    <div className="modal-content-padding">
      <CalendarHeader>
        <div className="left-content">
          <div className="icon">{icon && icon}</div>
          <div>{title}</div>
        </div>
        <div className="close-icon" onClick={()=>onClose ? onClose() :onCancel()}>
          {AdminCloseIcon()}
        </div>
      </CalendarHeader>
      <Border/>
      <CalendarWrapper>
        <ConfirmVisitText>{description}</ConfirmVisitText>
        {subDescription ? <ConfirmVisitText  margin={isPopupMargin} isColor= {descriptionColor || "#C13D4D"}> {subDescription}</ConfirmVisitText> : <ConfirmVisitText  margin={isPopupMargin} isColor= {descriptionColor || "#C13D4D"}> You’ve earned <span style={{fontWeight:'700'}}>{surveyPoints} XP</span> for your participation!</ConfirmVisitText>}
        {note ? (<div className="second-text">
          {note}
        </div>):null}
      </CalendarWrapper>
    </div>

    <Modal.Footer style={{borderTop:'none',display:'flex',paddingTop:'0px',justifyContent:'center'}}>

      <ButtonContainer>
        {cancelText ?<Button
          isWidth="100px"
          isHeight="40px"
          background="transparent"
          color="#184A61"
          isFont={isFontSize}
          backgroundHover="none"
          onClick={onCancel}
        >
          {cancelText}
        </Button>:null}
        <Button
          isWidth={confirmButtonWidth}
          isHeight="40px"
          isFont={isFontSize}
          background="#DA6C74"
          color="white"
          onClick={onConfirm}
        >{buttonIcon && buttonIcon}
          <div className="btn-text">{confirmButtonText}</div>
        </Button>
      </ButtonContainer>

    </Modal.Footer>
  </StyledModal>
);


CompletedSurveyPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  title:PropTypes.string, 
  confirmText: PropTypes.string, 
  description: PropTypes.string.isRequired,
  subDescription: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  cancelText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  modalWidth: PropTypes.string,
  modalHeight: PropTypes.string,
  icon: PropTypes.node.isRequired, 
  buttonIcon:PropTypes.node.isRequired, 
  confirmButtonWidth:PropTypes.string, 
  onClose:PropTypes.func,
  note:PropTypes.string,
  descriptionColor: PropTypes.string,
  isFontSize: PropTypes.string,
  isPopupMargin: PropTypes.string,
  surveyPoints:PropTypes.number
};
  


export default CompletedSurveyPopup;
